import React, { useState, useEffect, useContext } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid2";
import Leaderboard from "../components/Home/LeaderBoard";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import TrendingItem from "../components/Home/TrendingItem";
import axios from "axios";
import { toast } from "react-toastify";
import Loader from "../components/Utils/Loader";
import PageContainer from "./PageContainer";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import ExpandLessRoundedIcon from "@mui/icons-material/ExpandLessRounded";
import { Link } from "react-router-dom";
import Welcome from "../components/Home/Welcome";
import { AuthContext } from "../context/AuthContext";

const trendingData = [
  {
    title: "Trending in Scoring",
    date: "Yesterday",
    players: [
      {
        id: "2caleb_wilson",
        name: "Caleb Wilson",
        profileImg:
          "https://s3media.247sports.com/Uploads/Assets/982/434/12434982.jpeg?width=70&fit=crop",
        stats: [
          { value: 35, label: "points" },
          { value: "70%", label: "FG" },
          { value: "12/17", label: "FG" },
        ],
        result: "Win",
        event: "Game @ event",
        xfactor: "87",
      },
      {
        id: "22nikolas_khamenia",
        name: "Nikolas Khamenia",
        profileImg:
          "https://s3media.247sports.com/Uploads/Assets/625/481/12481625.jpg?width=70&fit=crop",
        stats: [
          { value: 28, label: "points" },
          { value: "72%", label: "FG" },
          { value: "13/18", label: "FG" },
        ],
        result: "Loss",
        event: "Game @ event",
        xfactor: "85",
      },
    ],
  },
  {
    title: "Trending in Rebounds",
    date: "3 Days Ago",
    players: [
      {
        id: "94cameron_boozer",
        name: "Cameron Boozer",
        profileImg:
          "https://s3media.247sports.com/Uploads/Assets/979/434/12434979.jpeg",
        stats: [
          { value: 14, label: "Rebounds" },
          { value: 10, label: "OFF" },
          { value: 4, label: "DEF" },
        ],
        result: "Win",
        event: "Game @ event",
        xfactor: "91",
      },
      {
        id: "36chris_cenac",
        name: "Chris Cenac",
        profileImg:
          "https://s3media.247sports.com/Uploads/Assets/341/824/11824341.jpeg?width=70&fit=crop",
        stats: [
          { value: 12, label: "Rebounds" },
          { value: 5, label: "OFF" },
          { value: 7, label: "DEF" },
        ],
        result: "Win",
        event: "Game @ Event Name",
        xfactor: "79",
      },
    ],
  },
  {
    title: "Trending in Assists",
    date: "Today",
    players: [
      {
        id: "0keyshuan_tillery",
        name: "Keyshuan Tillery",
        profileImg:
          "https://s3media.247sports.com/Uploads/Assets/895/860/11860895.jpeg?width=70&fit=crop",
        stats: [
          { value: 11, label: "Assists" },
          { value: 0, label: "Turnovers" },
        ],
        result: "Win",
        event: "Game @ event",
        xfactor: "79",
      },
      {
        id: "0jj_mandaquit",
        name: "JJ Mandaquit",
        profileImg:
          "https://s3media.247sports.com/Uploads/Assets/841/794/11794841.jpeg?width=70&fit=crop",
        stats: [
          { value: 9, label: "Assists" },
          { value: 1, label: "Turnover" },
        ],
        result: "Loss",
        event: "Game @ event",
        xfactor: "81",
      },
    ],
  },
];
const HomePage = () => {
  const { userInfo, isNewUser, setIsNewUser } = useContext(AuthContext);
  const [showWelcome, setShowWelcome] = useState(false);
  const [loading, setLoading] = useState(true);
  const [leaderboardData, setLeaderboardData] = useState({
    pointsLeaderboard: [],
    assistsLeaderboard: [],
    reboundsLeaderboard: [],
    overallLeaderboard: [],
    defenseLeaderboard: [],
    playmakingLeaderboard: [],
    ball_handlingLeaderboard: [],
  });
  const [expandedBoards, setExpandedBoards] = useState({
    overall: true,
    points: false,
    rebounds: false,
    assists: false,
    defense: false,
    playmaking: false,
    ball_handling: false,
  });

  // Handle showing welcome modal for new users
  useEffect(() => {
    if (isNewUser && userInfo) {
      setShowWelcome(true);
    }
  }, [isNewUser, userInfo]);

  const handleCloseWelcome = () => {
    // Just hide the modal visually, but keep the isNewUser state
    // This way if they refresh and aren't verified, they'll still see it
    setShowWelcome(false);
  };

  const toggleBoard = (board) => {
    setExpandedBoards((prev) => ({
      ...prev,
      [board]: !prev[board],
    }));
  };

  useEffect(() => {
    // // Fetch player list
    axios
      .post("/api/players/leaderboard-data", { withCredentials: true })
      .then((response) => {
        console.log("back");
        setLeaderboardData(response.data);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        toast.error("Failed to load players");
      });
  }, []);
  if (loading) {
    return <Loader />;
  }
  return (
    <PageContainer>
      {/* Only show welcome if 1) user is new, 2) welcome modal is visible, 3) user is not verified */}
      {showWelcome && userInfo && isNewUser && !userInfo.verified && (
        <Welcome user={userInfo} onClose={handleCloseWelcome} />
      )}
      <Grid container spacing={2}>
        <Grid className="trending-home-container" xs={12} md={6}>
          {trendingData.map((data, index) => (
            <TrendingItem
              key={index}
              title={data.title}
              date={data.date}
              players={data.players}
            />
          ))}
        </Grid>
        <Grid xs={12} md={6}>
          <div className="leader-home">
            <div
              className="trending-home-header"
              onClick={() => toggleBoard("overall")}
              style={{ cursor: "pointer" }}
            >
              <p className="trending-home-title">
                <EmojiEventsIcon
                  sx={{ color: "#5d87ff", verticalAlign: "bottom" }}
                />
                Overall Leaderboard
              </p>
              <div
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                <span style={{ opacity: "0.4" }}>Updated 2 hours ago</span>
                {expandedBoards.overall ? (
                  <ExpandLessRoundedIcon />
                ) : (
                  <ExpandMoreRoundedIcon />
                )}
              </div>
            </div>
            {expandedBoards.overall && (
              <>
                <div className="leader-home-content">
                  <Leaderboard
                    data={leaderboardData.overallLeaderboard}
                    type="overall"
                  />
                </div>
                <Link
                  to="/leaderboard?type=overall"
                  className="leader-home-see-full"
                >
                  See Full List →
                </Link>
              </>
            )}
          </div>
          <div className="leader-home">
            <div
              className="trending-home-header"
              onClick={() => toggleBoard("points")}
              style={{ cursor: "pointer" }}
            >
              <p className="trending-home-title">
                <EmojiEventsIcon
                  sx={{ color: "#5d87ff", verticalAlign: "bottom" }}
                />
                Points
              </p>
              <div
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                <span style={{ opacity: "0.4" }}>Updated 2 hours ago</span>
                {expandedBoards.points ? (
                  <ExpandLessRoundedIcon />
                ) : (
                  <ExpandMoreRoundedIcon />
                )}
              </div>
            </div>
            {expandedBoards.points && (
              <>
                <div className="leader-home-content">
                  <Leaderboard
                    data={leaderboardData.pointsLeaderboard}
                    type="points"
                  />
                </div>
                <Link
                  to="/leaderboard?type=points"
                  className="leader-home-see-full"
                >
                  See Full List →
                </Link>
              </>
            )}
          </div>
          <div className="leader-home">
            <div
              className="trending-home-header"
              onClick={() => toggleBoard("rebounds")}
              style={{ cursor: "pointer" }}
            >
              <p className="trending-home-title">
                <EmojiEventsIcon
                  sx={{ color: "#5d87ff", verticalAlign: "bottom" }}
                />
                Rebounds
              </p>
              <div
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                <span style={{ opacity: "0.4" }}>Updated 2 hours ago</span>
                {expandedBoards.rebounds ? (
                  <ExpandLessRoundedIcon />
                ) : (
                  <ExpandMoreRoundedIcon />
                )}
              </div>
            </div>
            {expandedBoards.rebounds && (
              <>
                <div className="leader-home-content">
                  <Leaderboard
                    data={leaderboardData.reboundsLeaderboard}
                    type="rebounds"
                  />
                </div>
                <Link
                  to="/leaderboard?type=rebounds"
                  className="leader-home-see-full"
                >
                  See Full List →
                </Link>
              </>
            )}
          </div>
          <div className="leader-home">
            <div
              className="trending-home-header"
              onClick={() => toggleBoard("assists")}
              style={{ cursor: "pointer" }}
            >
              <p className="trending-home-title">
                <EmojiEventsIcon
                  sx={{ color: "#5d87ff", verticalAlign: "bottom" }}
                />
                Assists
              </p>
              <div
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                <span style={{ opacity: "0.4" }}>Updated 2 hours ago</span>
                {expandedBoards.assists ? (
                  <ExpandLessRoundedIcon />
                ) : (
                  <ExpandMoreRoundedIcon />
                )}
              </div>
            </div>
            {expandedBoards.assists && (
              <>
                <div className="leader-home-content">
                  <Leaderboard
                    data={leaderboardData.assistsLeaderboard}
                    type="assists"
                  />
                </div>
                <Link
                  to="/leaderboard?type=assists"
                  className="leader-home-see-full"
                >
                  See Full List →
                </Link>
              </>
            )}
          </div>
          <div className="leader-home">
            <div
              className="trending-home-header"
              onClick={() => toggleBoard("defense")}
              style={{ cursor: "pointer" }}
            >
              <p className="trending-home-title">
                <EmojiEventsIcon
                  sx={{ color: "#5d87ff", verticalAlign: "bottom" }}
                />
                Defense
              </p>
              <div
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                <span style={{ opacity: "0.4" }}>Updated 2 hours ago</span>
                {expandedBoards.defense ? (
                  <ExpandLessRoundedIcon />
                ) : (
                  <ExpandMoreRoundedIcon />
                )}
              </div>
            </div>
            {expandedBoards.defense && (
              <>
                <div className="leader-home-content">
                  <Leaderboard
                    data={leaderboardData.defenseLeaderboard}
                    type="defense"
                  />
                </div>
                <Link
                  to="/leaderboard?type=defense"
                  className="leader-home-see-full"
                >
                  See Full List →
                </Link>
              </>
            )}
          </div>
          <div className="leader-home">
            <div
              className="trending-home-header"
              onClick={() => toggleBoard("playmaking")}
              style={{ cursor: "pointer" }}
            >
              <p className="trending-home-title">
                <EmojiEventsIcon
                  sx={{ color: "#5d87ff", verticalAlign: "bottom" }}
                />
                Playmaking
              </p>
              <div
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                <span style={{ opacity: "0.4" }}>Updated 2 hours ago</span>
                {expandedBoards.playmaking ? (
                  <ExpandLessRoundedIcon />
                ) : (
                  <ExpandMoreRoundedIcon />
                )}
              </div>
            </div>
            {expandedBoards.playmaking && (
              <>
                <div className="leader-home-content">
                  <Leaderboard
                    data={leaderboardData.playmakingLeaderboard}
                    type="playmaking"
                  />
                </div>
                <Link
                  to="/leaderboard?type=playmaking"
                  className="leader-home-see-full"
                >
                  See Full List →
                </Link>
              </>
            )}
          </div>
          <div className="leader-home">
            <div
              className="trending-home-header"
              onClick={() => toggleBoard("ball_handling")}
              style={{ cursor: "pointer" }}
            >
              <p className="trending-home-title">
                <EmojiEventsIcon
                  sx={{ color: "#5d87ff", verticalAlign: "bottom" }}
                />
                Ball Handling
              </p>
              <div
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                <span style={{ opacity: "0.4" }}>Updated 2 hours ago</span>
                {expandedBoards.ball_handling ? (
                  <ExpandLessRoundedIcon />
                ) : (
                  <ExpandMoreRoundedIcon />
                )}
              </div>
            </div>
            {expandedBoards.ball_handling && (
              <>
                <div className="leader-home-content">
                  <Leaderboard
                    data={leaderboardData.ball_handlingLeaderboard}
                    type="ball_handling"
                  />
                </div>
                <Link
                  to="/leaderboard?type=ball_handling"
                  className="leader-home-see-full"
                >
                  See Full List →
                </Link>
              </>
            )}
          </div>
        </Grid>
      </Grid>
    </PageContainer>
  );
};

export default HomePage;
